import { ChatBotApi } from "@/chatBot/api/requests";
import { URLS } from "../define";
import { IUnifiedPortalAPI, UnifiedPortalAPI } from "./api/unifiedPortal";
import { useConfigStore } from "@/stores/config";

export const unifiedApi: IUnifiedPortalAPI = new UnifiedPortalAPI(URLS.UP_ENDPOINT);

//Export a singleton instance of the ChatBotApi
const chatBotApiURL = `${URLS.UP_ENDPOINT.protocol}://${URLS.UP_ENDPOINT.hostname}${URLS.UP_ENDPOINT.port ? `:${URLS.UP_ENDPOINT.port}` : ""}`;
export const chatBotApi: ChatBotApi = new ChatBotApi(chatBotApiURL);
// export const unifiedApi: IUnifiedPortalAPI = FLAGS.IS_DEBUG
//   ? new UnifiedPortalAPIMock(URLS.UP_ENDPOINT)
//   : new UnifiedPortalAPI(URLS.UP_ENDPOINT);

export const initialize = async () => {
  const store = useConfigStore();
  await store.getConfig();
};
